
import React, { useState, useEffect } from "react";
import app from "../../../firebaseConfig";
import { getDatabase, ref, get } from "firebase/database";
import { motion } from "framer-motion"; // Importamos framer-motion
import { useNavigate,useSearchParams } from "react-router-dom"; // Importamos useNavigate

import Lottie from "react-lottie-player";
import rayoazul from './assets/lottie/rayoazul.json';
import lineasblancasvolando from './assets/lottie/lineasblancasvolando.json';
import efectoparticulas from './assets/lottie/efectoparticulas.json';
import fuegorojo from './assets/lottie/fuegorojo.json';
import fuegoamarillo from './assets/lottie/fuegoamarillo.json';
import neutron from './assets/lottie/neutron.json';
import ondacircular from './assets/lottie/ondacircular.json';

import CarruselImagenes from "./3dfyrioncarruselimgs";
import BannerRotativo from "./3dfyrionbannerrotativo"; //
import Testimonios from "./3dfyriontestimonios"; //

import { cacheImage } from "../../../utils/cacheImage";


import { FaBars, FaShoppingCart, FaUser, FaSearch } from "react-icons/fa";

// Función para mezclar un array aleatoriamente (Fisher-Yates Shuffle)
const shuffleArray = (array) => {
    return array
      .map((item) => ({ item, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ item }) => item);
  };
  
  export function slugify(text) {
    if (!text) return "";
    return encodeURIComponent(
      text
        .toString()
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
    );
  }

  export default function AwooEntrada({ setView, navigate }) {
  const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [carritoCantidad, setCarritoCantidad] = useState(0); // 🔹 Estado del carrito

  const [searchParams] = useSearchParams();
  const mesa = searchParams.get("mesa"); // Obtiene el número de la mesa

  const [mostrarBusqueda, setMostrarBusqueda] = useState(false);

  const [productosP, setProductosP] = useState([]);
const [productosD, setProductosD] = useState([]);

const [menuAbierto, setMenuAbierto] = useState(false);
  
const isMobile = typeof window !== "undefined" && window.innerWidth <= 480;


  const [productos, setProductos] = useState([]);
  
  const [vista, setVista] = useState("INICIO");

  const toggleBusqueda = () => {
    setMostrarBusqueda(!mostrarBusqueda);
  };

  //////////////// Por si se ve en CEL LOGICA DE REDIMENSION
  const [esMovil, setEsMovil] = useState(false);

  useEffect(() => {
    const manejarResize = () => {
      setEsMovil(window.innerWidth < 600); // ← Define punto de quiebre para "pantallas pequeñas"
    };

    manejarResize(); // Ejecutar en el primer render
    window.addEventListener("resize", manejarResize);
    return () => window.removeEventListener("resize", manejarResize);
  }, []);
  /////////////


  // Arreglo de animaciones disponibles
  const animacionesDisponibles = [
    lineasblancasvolando,
    efectoparticulas,
    fuegoamarillo,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    neutron,
    ondacircular,
    ondacircular,
    ondacircular,
    fuegoamarillo,
  ];
  

  //---------------------------------------------------------------------------------
  const tiempoMaximoCache = 1000 * 60 * 30; // 30 minutos
// Guardar y obtener productos del localStorage
  const guardarProductosEnLocalStorage = (productos) => {
    const data = {
      productos,
      timestamp: Date.now(),
    };
    localStorage.setItem("productosSoporteCelular", JSON.stringify(data));
  };
  
  const obtenerProductosDeLocalStorage = () => {
    const data = localStorage.getItem("productosSoporteCelular");
    if (!data) return null;
  
    const { productos, timestamp } = JSON.parse(data);
    if (Date.now() - timestamp > tiempoMaximoCache) return null; // Expirado
    return productos;
  };
  //---------------------------------------------------------------------------------
  




// 🔹 Función para obtener el carrito desde localStorage
const obtenerCarrito = () => {
  const carrito = localStorage.getItem("carrito");
  return carrito ? JSON.parse(carrito) : [];
};

     // 🔹 Obtener carrito al cargar la página
     useEffect(() => {
      setCarritoCantidad(obtenerCarrito().length);
    }, []);


  ////////////////////////////////////
  // Selecciona una animación aleatoria al montar el componente
  useEffect(() => {
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);
////////////////////////

  // Función para navegar a awoovistaitem.js
  const verProducto = (producto, mesa) => {
    const categoria = producto.categoria || producto.Categoria || "sin-categoria";
    const slug = producto.id ? String(producto.id) : slugify(producto.Titulo || producto.titulo);
  
    // Construimos URL segura
    const url = `/${encodeURIComponent(categoria)}/${encodeURIComponent(slug)}`;
  
    navigate(url, {
      state: {
        producto, // pasamos todo el objeto para optimizar carga
        mesa,     // si lo necesitas
      },
      replace: false, // normalmente false para permitir back
    });
  };

  //////////////////////////////////////////////////////////////////////
// Categoria - Lista de Productos P
useEffect(() => {
  async function cargarProductos() {
    // 1️⃣ Cargar desde Storage
    const guardados = localStorage.getItem("productosP");
    if (guardados) {
      setProductosP(JSON.parse(guardados));
    }

    // 2️⃣ Firebase
    const db = getDatabase(app);
    const categoriasRef = ref(db, `nature/Awoo/Categorias`);
    const snapshot = await get(categoriasRef);
    if (!snapshot.exists()) return;

    const categoriasData = snapshot.val();
    const productosFiltrados = [];

    for (const categoriaKey of Object.keys(categoriasData)) {
      const productosDeCategoria = categoriasData[categoriaKey];
      if (!productosDeCategoria) continue;

      for (const productoKey of Object.keys(productosDeCategoria)) {
        const prod = productosDeCategoria[productoKey];
        if (!prod) continue;

        const estado = prod.Estado ?? prod.estado ?? "";
        const tieneP = estado.includes("P");
        const esVisible = prod.visibilidad?.toLowerCase() === "si";

        if (tieneP && esVisible) {
          // ⭐ Cachear imagen del producto
          if (prod.img) {
            prod.imgCached = await cacheImage(prod.img, productoKey); 
          }

          productosFiltrados.push({
            id: productoKey,
            categoria: categoriaKey,
            ...prod,
          });
        }
      }
    }

    const aleatorios = productosFiltrados.sort(() => 0.5 - Math.random());
    const seleccion = aleatorios.slice(0,7);

    setProductosP(seleccion);
    localStorage.setItem("productosP", JSON.stringify(seleccion));
  }

  cargarProductos();
}, []);

// Categoria - Lista de Productos D
useEffect(() => {
  async function cargarProductos() {
    const guardados = localStorage.getItem("productosD");
    if (guardados) {
      setProductos(JSON.parse(guardados));
    }

    const db = getDatabase(app);
    const categoriasRef = ref(db, `nature/Awoo/Categorias`);
    const snapshot = await get(categoriasRef);
    if (!snapshot.exists()) return;

    const categoriasData = snapshot.val();
    const productosFiltrados = [];

    for (const categoriaKey of Object.keys(categoriasData)) {
      const productosDeCategoria = categoriasData[categoriaKey];
      if (!productosDeCategoria) continue;

      for (const productoKey of Object.keys(productosDeCategoria)) {
        const prod = productosDeCategoria[productoKey];
        if (!prod) continue;

        const estado = prod.Estado ?? prod.estado ?? "";
        const tieneD = estado.includes("D");
        const esVisible = prod.visibilidad?.toLowerCase() === "si";

        if (tieneD && esVisible) {
          if (prod.img) {
            prod.imgCached = await cacheImage(prod.img, productoKey);
          }

          productosFiltrados.push({
            id: productoKey,
            categoria: categoriaKey,
            ...prod,
          });
        }
      }
    }

    const aleatorios = productosFiltrados.sort(() => 0.5 - Math.random());
    const seleccion = aleatorios.slice(0, 7);

    setProductos(seleccion);
    localStorage.setItem("productosD", JSON.stringify(seleccion));
  }

  cargarProductos();
}, []);

//Codigo para cargar CATEGORIAS
useEffect(() => {
  async function cargarCategorias() {
    // 1️⃣ Intentar cargar desde cache
    const guardadas = localStorage.getItem("categoriasAwoo");
    if (guardadas) {
      setCategorias(JSON.parse(guardadas));
    }

    // 2️⃣ Firebase
    const db = getDatabase(app);
    const categoriasRef = ref(db, "nature/Awoo/Categorias");
    const snapshot = await get(categoriasRef);
    if (!snapshot.exists()) return;

    const categoriasData = snapshot.val();
    const categoriasArray = Object.keys(categoriasData);
    const resultado = [];

    for (const categoria of categoriasArray) {
      const visibleSnapshot = await get(ref(db, `nature/Awoo/Control/Visible/Categorias/${categoria}`));
      const visible = visibleSnapshot.exists() ? visibleSnapshot.val().toLowerCase() : "no";

      if (visible === "si") {
        const imgSnapshot = await get(ref(db, `nature/Awoo/Img/${categoria}`));
        const imgUrl = imgSnapshot.exists() ? imgSnapshot.val() : "";

        let imgCached = "";
        if (imgUrl) imgCached = await cacheImage(imgUrl, "cat_" + categoria);

        resultado.push({ nombre: categoria, img: imgCached || imgUrl });
      }
    }

    const mezcladas = resultado.sort(() => 0.5 - Math.random());

    setCategorias(mezcladas);
    localStorage.setItem("categoriasAwoo", JSON.stringify(mezcladas));
  }

  cargarCategorias();
}, []);










///////////////////
//Codigo para barra deslizante infinita
const mensajes = [
    "🚚 Envíos a toda Colombia",
    "⏳ ¡Tiempo limitado!",
    "🎉 Después de 5 Unidades Descuento 30%",
    "💎 Exclusivo en nuestra tienda",
    "🎯 Ideal para regalar",
    "🎈 ¡Aprovecha antes que se agote!"
  ];

  // Repetimos los mensajes para dar continuidad
  const contenido = [...mensajes, ...mensajes];
///////////////





  const handleCategoriaClick = (categoria) => {
    navigate("/awooproductosusuario", { state: { categoria, mesa  } }); // Navegar con estado
  };
  
  // 🔹 Función para redirigir al resumen de compras
  const irAlCarrito = () => {
    navigate("/3dfyrionresumen", { state: { mesa } });
  };

    return (
        <div style={{ display: "flex",overflowX: "hidden" , width: "100%", boxSizing: "border-box", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "#000", color: "white", textAlign: "center"}}>    


{/* ------------------ BARRA LATERAL ------------------------ */}
<motion.div
  initial={{ x: "-100%" }}
  animate={{ x: menuAbierto ? 0 : "-100%" }}
  transition={{ duration: 0.3, ease: "easeOut" }}
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "280px",
    height: "100vh",
    backgroundColor: "#111",
    color: "#fff",
    zIndex: 9999,
    padding: "20px",
    boxShadow: "4px 0 12px rgba(0,0,0,0.5)",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  }}
>
  {/* Botón cerrar */}
  <div style={{ display: "flex", justifyContent: "flex-end" }}>
    <button
      onClick={() => setMenuAbierto(false)}
      style={{
        background: "none",
        border: "none",
        color: "white",
        fontSize: "26px",
        cursor: "pointer",
      }}
    >
      ✖
    </button>
  </div>

  {/* Opciones principales */}
  <div style={{ marginTop: "10px", marginBottom: "20px" }}>
    {["INICIO", "PRODUCTOS", "SIMULADORES"].map((opcion) => (
      <div
        key={opcion}
        onClick={() => {
          if (opcion === "INICIO") navigate("/");
          if (opcion === "PRODUCTOS") navigate("/3dfyrioninicioproductos");
          if (opcion === "SIMULADORES") navigate("/3dfyrioninicionosotros");
          setMenuAbierto(false);
        }}
        style={{
          padding: "12px 0",
          paddingLeft: "5px",
          fontWeight: "bold",
          fontSize: "16px",
          cursor: "pointer",
          borderBottom: "1px solid #333",
        }}
      >
        {opcion}
      </div>
    ))}
  </div>

  {/* Categorías visibles */}
  <div style={{ marginTop: "10px" }}>
    <h3 style={{ fontSize: "14px", color: "#bbb", marginBottom: "10px" }}>
      CATEGORÍAS
    </h3>

    {categorias.map((cat, index) => (
      <div
        key={index}
        onClick={() => {
          handleCategoriaClick(cat.nombre);
          setMenuAbierto(false);
        }}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 0",
          cursor: "pointer",
          borderBottom: "1px solid #222",
          gap: "10px",
        }}
      >
        <img
          src={cat.img}
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "6px",
            objectFit: "cover",
          }}
        />
        <span style={{ fontSize: "15px" }}>{cat.nombre}</span>
      </div>
    ))}
  </div>
</motion.div>

{/* Fondo oscuro cuando menú está abierto */}
{menuAbierto && (
  <div
    onClick={() => setMenuAbierto(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 9998,
    }}
  ></div>
)}
{/* ---------------------------------------------------------- */}


  {/* Encabezado */}
  <div
      style={{
        width: "100%",
        height: "70px",
        backgroundColor: "#111",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      {/* Lado izquierdo - botón de menú y logo + lupa */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          marginLeft: "15px",
        }}
      >
        
      {/* */}
      <FaBars 
  size={35} 
  style={{ cursor: "pointer" }} 
  onClick={() => setMenuAbierto(true)}
/>

        
        <img
          src="images/dragonfondo2.png"
          alt="Logo"
          style={{
            height: "75px",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />
        <FaSearch
          size={20}
          style={{ cursor: "pointer" }}
          onClick={toggleBusqueda}
        />
      </div>

      {/* Centro - barra de búsqueda */}
      {mostrarBusqueda && (
        <input
          type="text"
          placeholder="Buscar..."
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            width: "50%",
            height: "35px",
            borderRadius: "8px",
            padding: "0 15px",
            border: "none",
            outline: "none",
            fontSize: "16px",
          }}
        />
      )}

      {/* Lado derecho - carrito + contador + perfil */}
{/* --- Icono Carrito Compras (Se oculta si carritoCantidad es 0) --- */}
{carritoCantidad > 0 && (
  <div
    onClick={irAlCarrito}
    style={{
      position: "relative",
      width: "48px",
      cursor: "pointer",
      marginRight:"19px"
    }}
  >
    <div
      style={{
        width: "38px",
        height: "38px",
        borderRadius: "50%",
        border: "3px solid #2ae5e2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url('images/carrito.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    ></div>

    {/* Etiqueta inferior con cantidad */}
    <div
      style={{
        position: "absolute",
        bottom: "-10px",
        left: "45%",
        transform: "translateX(-50%)",
        backgroundColor: "#fa0a02",
        color: "white",
        padding: "4px 5px",
        borderRadius: "10px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "12px",
      }}
    >
      {carritoCantidad}
    </div>
  </div>
)}
    </div>

    {/* BARRA DE NAVEGACIÓN */}
<div
  style={{
    width: "100%",
    backgroundColor: "#111",
    display: "flex",
    justifyContent: "center",
    padding: "10px 0",
    boxShadow: "0 2px 10px rgba(0,0,0,0.5)",
    position: "sticky", // opcional: se queda arriba
    top: 0,
    zIndex: 999,
  }}
>
  <div
    style={{
      width: "95%",
      maxWidth: "1200px",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      gap: "20px",
      flexWrap: "wrap", // para que sea responsive
    }}
  >
    
    {["INICIO", "PRODUCTOS", "SIMULADORES"].map((opcion) => (
  <button
    key={opcion}
    onClick={() => {
    if (opcion === "INICIO") setView("INICIO");
     if (opcion === "PRODUCTOS") setView("PRODUCTOS");
     if (opcion === "SIMULADORES") setView("SIMULADORES");
    }}
    style={{
      background: opcion === "INICIO" ? "white" : "none",
      color: opcion === "INICIO" ? "black" : "white",
      border: "none",
      fontWeight: "bold",
      fontSize: "11px",
      cursor: "pointer",
      padding: "12px",
      borderRadius: "6px",
    }}
  >
    {opcion}
  </button>
))}


  </div>
</div>

  {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
         marginTop:"2px"
      }}
    >
    </div>




  {/* Barra Deslizante */}
  <div
      style={{
        width: "100%",
        height: "35px",
        backgroundColor: "#222",
        color: "#fff",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: "bold",
      }}
    >
      <div
        style={{
          display: "inline-block",
          whiteSpace: "nowrap",
          animation: "mover 8s linear infinite",
        }}
      >
        {contenido.map((texto, index) => (
          <span key={index} style={{ marginRight: "60px" }}>
            {texto}
          </span>
        ))}
      </div>

      {/* Animación CSS */}
      <style>
        {`
          @keyframes mover {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}
      </style>
    </div>

  {/* Animación de fondo */}
   <div
  style={{
    marginLeft: "15px",
    position: "relative",
    flexShrink: 0, // Evita que las tarjetas se reduzcan
  }}
>

 {/* Animación de fondo */}
 <Lottie
      animationData={animacionSeleccionada} // Importa correctamente la animación JSON
      play
      loop
      style={{
        position: 'absolute', // Fija la animación al fondo de la ventana
        justifyContent: "center",
        width: '700px',
        height: '700px',
        top: '0',
        left: '0',
        zIndex: 0, // Detrás del contenido
        pointerEvents: 'none', // Para que no interfiera con los clics
      }}
    />


   </div>


<CarruselImagenes />


{/* BENEFICIOS HORIZONTALES */}
<div
  style={{
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "30px 0",
    marginTop:"10px"
  }}
>
  <div
    style={{
      width: "95%",
      maxWidth: "1200px",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      gap: "10px",
      flexWrap: "wrap", // por si se ve en celular
    }}
  >
    {/* Ítem individual */}
    {[
      { texto: "Hecho en Colombia", img: "https://img.freepik.com/fotos-premium/trazo-pincel-bandera-colombia-bandera-nacional-sobre-fondo-blanco_559531-8514.jpg" },
      { texto: "Calidad Garantizada", img: "https://cdn-icons-png.flaticon.com/512/190/190411.png" },
      { texto: "Soporte Dedicado", img: "https://cdn-icons-png.flaticon.com/512/2333/2333501.png" },
      { texto: "Pago Seguro", img: "https://w7.pngwing.com/pngs/883/891/png-transparent-padlock-key-self-storage-security-padlock-technic-logo-android-thumbnail.png" },
    ].map((item, index) => (
      <div
        key={index}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "150px",
          textAlign: "center",
        }}
      >
        <img
          src={item.img}
          alt={item.texto}
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            objectFit: "cover",
            marginBottom: "5px",
            backgroundColor: "#fff",
            padding: "5px",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        />
        <span style={{ fontWeight: "bold", fontSize: "14px", color: "#fff" }}>
          {item.texto}
        </span>
      </div>
    ))}
  </div>
</div>




{/* BLOQUE COMPLETO DE "Productos Populares (P)" */}
<div
  style={{
    width: "80%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#000",
    padding: "20px 0"
  }}
>
  <div
    style={{
      width: "100%",
      maxWidth: "1200px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    {/* Título + Botón */}
    <div
      style={{
        width: "100%",
        padding: "10px 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ fontWeight: "bold", fontSize: "20px", color: "white" }}>
        💥 Populares:
      </div>

      <button
        style={{
          backgroundColor: "#8ac20b",
          color: "white",
          fontWeight: "bold",
          border: "none",
          borderRadius: "20px",
          padding: "10px 20px",
          cursor: "pointer",
          fontSize: "16px",
        }}
        onClick={() => console.log("Ver más clickeado")}
      >
        Ver Más
      </button>
    </div>

    {/* Contenedor de Tarjetas */}
    <div
      style={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: isMobile
          ? "repeat(2, minmax(120px, 1fr))" // más estrechas en móviles
          : "repeat(auto-fit, minmax(160px, 1fr))",
        gap: isMobile ? "8px" : "12px",
        paddingBottom: "10px",
      }}
    >
      {/* Tarjetas de Productos */}
      {productosP
        .filter((producto) => producto.visibilidad === "Si")
        .map((producto) => {
          const tienePrecioAnterior =
            producto.PrecioAnterior && producto.PrecioAnterior !== 0;

          const porcentajeDescuento = tienePrecioAnterior
            ? Math.round(100 - (producto.Precio * 100) / producto.PrecioAnterior)
            : null;

          return (
            <div
              key={producto.id}
              onClick={() => verProducto(producto)}
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
                padding: isMobile ? "8px" : "10px",
                textAlign: "center",
                border: "1px solid #02f2fa",
                boxShadow: "0 0 10px rgba(2, 242, 250, 0.7)",
                cursor: "pointer",
                position: "relative",
              }}
            >
              {/* Imagen */}
              <div style={{ position: "relative" }}>
                <img
                  src={(() => {
                    let imagenUrl = producto.Img;
                    if (!imagenUrl && producto.Visuales) {
                      const visualesArray = Object.values(producto.Visuales)
                        .filter((item) => item && item.tipo === "imagen")
                        .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));

                      if (visualesArray.length > 0) {
                        imagenUrl = visualesArray[0].url;
                      }
                    }
                    return imagenUrl || "images/default.jpg";
                  })()}
                  alt={producto.Titulo || "Producto"}
                  style={{
                    width: "100%",
                    height: isMobile ? "120px" : "150px",
                    objectFit: "cover",
                    borderRadius: "10%",
                  }}
                />

                {/* Descuento */}
                {tienePrecioAnterior && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      left: "8px",
                      backgroundColor: "#b016b5",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "8px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    -{porcentajeDescuento}% OFF
                  </div>
                )}
              </div>

              {/* Título */}
              <div
                style={{
                  color: "black",
                  fontWeight: "bold",
                  marginTop: "10px",
                  height: isMobile ? "32px" : "38px",
                  fontSize: isMobile ? "12px" : "14px",
                }}
              >
                {producto.Titulo || ""}
              </div>

              {/* Precio anterior */}
              {tienePrecioAnterior && (
                <div
                  style={{
                    color: "#7c7c7c",
                    fontSize: isMobile ? "13px" : "15px",
                    fontWeight: "bold",
                    textDecoration: "line-through",
                  }}
                >
                  ${producto.PrecioAnterior.toLocaleString("es-CO")}
                </div>
              )}

              {/* Precio actual */}
              <div
                style={{
                  marginTop: "5px",
                  backgroundColor: "#57a710",
                  color: "white",
                  padding: "5px",
                  borderRadius: "10px",
                  fontWeight: "bold",
                  fontSize: isMobile ? "14px" : "16px",
                }}
              >
                ${producto.Precio?.toLocaleString("es-CO") || "0"}
              </div>
            </div>
          );
        })}

      {/* Tarjeta final "+" */}
      <div
        onClick={() => console.log("Mostrar todos los productos")}
        style={{
          backgroundColor: "#ffffff",
          border: "2px dashed #ccc",
          borderRadius: "15px",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "50px",
          color: "#999",
          cursor: "pointer",
          transition: "background 0.3s",
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.backgroundColor = "#f7f7f7")
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.backgroundColor = "#ffffff")
        }
      >
        +
      </div>
    </div>
  </div>
</div>

{/* BLOQUE COMPLETO DE "Productos Destacados (D)" */}
<div
  style={{
    width: "80%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#000",
    padding: "20px 0",
    marginTop:"-35px"
  }}
>
  <div
    style={{
      width: "100%",
      maxWidth: "1200px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    {/* Título + Botón */}
    <div
      style={{
        width: "100%",
        padding: "10px 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ fontWeight: "bold", fontSize: "20px", color: "white" }}>
        💥 Destacados:
      </div>

      <button
        style={{
          backgroundColor: "#8ac20b",
          color: "white",
          fontWeight: "bold",
          border: "none",
          borderRadius: "20px",
          padding: "10px 20px",
          cursor: "pointer",
          fontSize: "16px",
        }}
        onClick={() => console.log("Ver más clickeado")}
      >
        Ver Más
      </button>
    </div>

    {/* Contenedor de Tarjetas */}
    <div
      style={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: isMobile
          ? "repeat(2, minmax(120px, 1fr))" // más estrechas en móviles
          : "repeat(auto-fit, minmax(160px, 1fr))",
        gap: isMobile ? "8px" : "12px",
        paddingBottom: "10px",
      }}
    >
      {/* Tarjetas de Productos */}
      {productos
        .filter((producto) => producto.visibilidad === "Si")
        .map((producto) => {
          const tienePrecioAnterior =
            producto.PrecioAnterior && producto.PrecioAnterior !== 0;

          const porcentajeDescuento = tienePrecioAnterior
            ? Math.round(100 - (producto.Precio * 100) / producto.PrecioAnterior)
            : null;

          return (
            <div
              key={producto.id}
              onClick={() => verProducto(producto.Titulo)}
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
                padding: isMobile ? "8px" : "10px",
                textAlign: "center",
                border: "1px solid #02f2fa",
                boxShadow: "0 0 10px rgba(2, 242, 250, 0.7)",
                cursor: "pointer",
                position: "relative",
              }}
            >
              {/* Imagen */}
              <div style={{ position: "relative" }}>
                <img
                  src={(() => {
                    let imagenUrl = producto.Img;
                    if (!imagenUrl && producto.Visuales) {
                      const visualesArray = Object.values(producto.Visuales)
                        .filter((item) => item && item.tipo === "imagen")
                        .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));

                      if (visualesArray.length > 0) {
                        imagenUrl = visualesArray[0].url;
                      }
                    }
                    return imagenUrl || "images/default.jpg";
                  })()}
                  alt={producto.Titulo || "Producto"}
                  style={{
                    width: "100%",
                    height: isMobile ? "120px" : "150px",
                    objectFit: "cover",
                    borderRadius: "10%",
                  }}
                />

                {/* Descuento */}
                {tienePrecioAnterior && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      left: "8px",
                      backgroundColor: "#b016b5",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "8px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    -{porcentajeDescuento}% OFF
                  </div>
                )}
              </div>

              {/* Título */}
              <div
                style={{
                  color: "black",
                  fontWeight: "bold",
                  marginTop: "10px",
                  height: isMobile ? "32px" : "38px",
                  fontSize: isMobile ? "12px" : "14px",
                }}
              >
                {producto.Titulo || ""}
              </div>

              {/* Precio anterior */}
              {tienePrecioAnterior && (
                <div
                  style={{
                    color: "#7c7c7c",
                    fontSize: isMobile ? "13px" : "15px",
                    fontWeight: "bold",
                    textDecoration: "line-through",
                  }}
                >
                  ${producto.PrecioAnterior.toLocaleString("es-CO")}
                </div>
              )}

              {/* Precio actual */}
              <div
                style={{
                  marginTop: "5px",
                  backgroundColor: "#57a710",
                  color: "white",
                  padding: "5px",
                  borderRadius: "10px",
                  fontWeight: "bold",
                  fontSize: isMobile ? "14px" : "16px",
                }}
              >
                ${producto.Precio?.toLocaleString("es-CO") || "0"}
              </div>
            </div>
          );
        })}

      {/* Tarjeta final "+" */}
      <div
        onClick={() => console.log("Mostrar todos los productos")}
        style={{
          backgroundColor: "#ffffff",
          border: "2px dashed #ccc",
          borderRadius: "15px",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "50px",
          color: "#999",
          cursor: "pointer",
          transition: "background 0.3s",
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.backgroundColor = "#f7f7f7")
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.backgroundColor = "#ffffff")
        }
      >
        +
      </div>
    </div>
  </div>
</div>



<BannerRotativo />




  {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
         marginTop:"9px",
         width:"60%"
      }}
    >
    </div>

{/* Título + Botón */}
<div
  style={{
    width: "100%",
    padding: "10px 0",
    display: "flex",
    justifyContent: "center", // 🔄 Cambiar aquí
    alignItems: "center",
    marginTop:"30px",
  }}
>
  <div style={{ fontWeight: "bold", fontSize: "16px", color: "white" }}>
  ✔️ CATEGORIAS
  </div>
</div>

{/* Botones de opciones */}
<div
      style={{
        marginTop:"-30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        textAlign: "center",
        padding: "10px",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: esMovil ? "10px" : "20px",
          width: "95%",
          padding: "10px",
        }}
      >
        {categorias.map((categoria, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            style={{
              cursor: "pointer",
              width: esMovil ? "150px" : "200px", // ← Ajuste para pantallas pequeñas
            }}
            onClick={() => handleCategoriaClick(categoria.nombre)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                padding: "10px 0",
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  maxWidth: esMovil ? "150px" : "200px",
                }}
              >
                <div
                  style={{
                    padding: "2px",
                    backgroundColor: "#4df9fc",
                    borderRadius: "6%",
                    width: "100%",
                  }}
                >
                  <img
                    src={categoria.img}
                    alt={categoria.nombre}
                    style={{
                      width: "100%",
                      height: esMovil ? "150px" : "200px",
                      objectFit: "cover",
                      borderRadius: "5%",
                      display: "block",
                    }}
                  />
                </div>
                <div
                  style={{
                    position: "absolute",
                    bottom: "-10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "70%", // Más ancho en móvil
                    backgroundColor: "#3cca07",
                    color: "white",
                    padding: "6px",
                    borderRadius: "10px",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: esMovil ? "12px" : "14px",
                  }}
                >
                  {categoria.nombre}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>

{/* Sección responsive con tarjetas en Grid */}
<div
  style={{
    backgroundColor: "#000",
    padding: "15px",
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
    marginTop: "29px"
  }}
>
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
      gap: "20px",
      width: "100%",
      justifyContent: "center",
    }}
  >
    {[...Array(4)].map((_, i) => (
      <div
        key={i}
        style={{
          padding: "10px",
          color: "white",
          backgroundColor: "#111",
          borderRadius: "12px",
          textAlign: "center",
          minWidth: "130px",
        }}
      >
        <div style={{ fontSize: "50px" }}>
          {i === 0
            ? "✅"
            : i === 1
            ? "🚚"
            : i === 2
            ? "💁‍♂️"
            : "🇨🇴"}
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            marginTop: "10px",
          }}
        >
          {i === 0
            ? "CALIDAD GARANTIZADA"
            : i === 1
            ? "ENVÍOS RÁPIDOS"
            : i === 2
            ? "SOPORTE TÉCNICO"
            : "HECHO EN COLOMBIA"}
        </div>
        <div
          style={{
            color: "#a0a09f",
            marginTop: "8px",
            fontSize: "14px",
          }}
        >
          {i === 0
            ? "Cada producto es fabricado con precisión, cuidado y materiales de primera calidad para asegurar tu satisfacción total."
            : i === 1
            ? "Tus pedidos realizados antes de las 3pm se enviarán el mismo día. Por compras superiores a $95.000 tu envío es GRATIS."
            : i === 2
            ? "Estamos siempre atentos a tus pedidos o requerimientos. Puedes contactarnos en los horarios disponibles a través de la pestaña de CONTACTO."
            : "Apoyas talento nacional, emprendimiento local y una marca que nace desde el corazón de Colombia 🇨🇴."}
        </div>
      </div>
    ))}
  </div>
</div>








<Testimonios />


{/* Redes Sociales */}
<div
  style={{
    display: "flex",
    justifyContent: "center",
    gap: "55px",
    padding: "20px 0 10px 0",
    marginTop: "-20px"
  }}
>
  {/* Facebook */}
  <a
    href="https://www.facebook.com"
    target="_blank"
    rel="noopener noreferrer"
    style={{ transition: "transform 0.2s" }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/145/145802.png"
      alt="Facebook"
      style={{ width: "35px", height: "35px" }}
    />
  </a>

  {/* Instagram */}
  <a
    href="https://www.instagram.com"
    target="_blank"
    rel="noopener noreferrer"
    style={{ transition: "transform 0.2s" }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/174/174855.png"
      alt="Instagram"
      style={{ width: "35px", height: "35px" }}
    />
  </a>

  {/* TikTok */}
  <a
    href="https://www.tiktok.com"
    target="_blank"
    rel="noopener noreferrer"
    style={{ transition: "transform 0.2s" }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    <img
      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT80SZY8HTO2WFnUzJP1zKcH-D4W60EDvkvHavHEi0bhp4NFbdXArJ2yWDJvCARoRF6vCg&usqp=CAU"
      alt="TikTok"
      style={{ width: "35px", height: "35px" }}
    />
  </a>
</div>


{/* Nombre de usuario */}
<div
  style={{
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#fff",
    marginBottom: "15px",
  }}
>
  @3dfyrion
</div>

{/* Footer */}
<div
  style={{
    width: "100%",
    padding: "15px 0",
    textAlign: "center",
    fontSize: "14px",
    color: "#777",
    borderTop: "1px solid #ccc",
  }}
>
  <span style={{ fontSize: "16px", marginRight: "5px" }}>©</span>
  2025, 3dFyrion Colombia | Tecnología y Diseño de 3dfyrion
</div>



</div>
    );



}

const botonEstilo = {
    width: "100%",
    padding: "15px",
    fontSize: "18px",
    fontWeight: "bold",
    background: "#e27f0e",
    color: "white",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "0.3s",
};
